import React from 'react';
import {
    PoolCharacteristics,
    PoolDetailsContainer,
    PoolDetailsItem,
} from './styled';
import dollar from '../../../images/icons/big9/dollarNew.svg';
import card from '../../../images/icons/big9/card.svg';
import user from '../../../images/icons/big9/user.svg';
import clock from '../../../images/icons/big9/clock.svg';
import useAuth from '../state/useAuth';
import get from 'lodash/get';
import {
    countDeadlineTime,
    countShares,
    countUserShares,
} from '../state/helpers';
import useCountdown from 'features/SpilKlub/state/useCountdown';

const getTotalPoolAmount = (pool) =>
    `${get(pool, ['payout', 'totalPoolAmount'], 0)} kr.`;

const getSharesSummary = (pool) =>
    `${countShares(pool)}/${get(pool, ['poolSettings', 'sharesLimit'], 0)}`;

const getUserShares = (pool, userId) => `${countUserShares(pool, userId)} stk.`;

const PoolInfoBlocks = ({ pool, status }) => {
    const { userId } = useAuth();

    const deadlineTime = countDeadlineTime(
        pool?.poolSettings?.deadlineTime,
        pool?.startTime
    );
    const { timeLeft } = useCountdown({
        deadlineTime,
        format: 'HH:mm:ss',
    });

    const pending = status === 'loading';
    const unavailable = pending || !pool;

    return (
        <PoolDetailsContainer>
            <PoolDetailsItem>
                <PoolCharacteristics
                    icon={dollar}
                    label={getTotalPoolAmount(pool)}
                    description={'I puljen'}
                />
            </PoolDetailsItem>
            <PoolDetailsItem>
                <PoolCharacteristics
                    icon={card}
                    label={unavailable ? ' ' : getSharesSummary(pool)}
                    description={'Solgte andele'}
                />
            </PoolDetailsItem>
            <PoolDetailsItem>
                <PoolCharacteristics
                    icon={user}
                    label={unavailable ? ' ' : getUserShares(pool, userId)}
                    description={'Dine andele'}
                />
            </PoolDetailsItem>
            <PoolDetailsItem>
                <PoolCharacteristics
                    icon={clock}
                    label={unavailable ? ' ' : timeLeft}
                    description={'Til deadline'}
                />
            </PoolDetailsItem>
        </PoolDetailsContainer>
    );
};

export default PoolInfoBlocks;
